import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

const mapStateToProps = state => ({
  global: state.Global,
  user: state.Dashboard.user
});

class AdminComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    let { history } = this.props;
    history.push('/admin/bookings');
  }


  render() {
    let { user } = this.props;
    if (!user) return (<div className="container text-center"><h4>Loading...</h4></div>)

    return (<div className="container admin-container">
      <div className="row pl-3 align-items-baseline">
        <h1>Welcome, Admin</h1>
      </div>
      <div className="row">
      </div>
    </div>);
  }
}


export default withRouter(connect(mapStateToProps)(AdminComponent));
